module.exports = __webpack_public_path__ + "img/weirenzheng.2fbfb264.png";